export const groupsTabs = {
  BROWSE: 'browse',
  MY_GROUPS: 'mygroups',
};
